import { Injectable, RendererFactory2, Renderer2, Inject } from "@angular/core";
import { DOCUMENT } from "@angular/common";

// To add theme to our application

@Injectable({
  providedIn: "root",
})
export class LayoutService {
  renderer: Renderer2;
  private currentBodyClass: string | null = null;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    rendererFactory: RendererFactory2
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  addBodyClass(bodyClass: string) {
    console.log("addBodyClass:", bodyClass);

    if (this.currentBodyClass && this.currentBodyClass !== bodyClass) {
      this.renderer.removeClass(this.document.body, this.currentBodyClass);
    }

    this.renderer.addClass(this.document.body, bodyClass);
    this.currentBodyClass = bodyClass;
  }
  removeBodyClass(bodyClass:string) {
   this.renderer.removeClass(this.document.body, bodyClass);
    if (this.currentBodyClass === bodyClass) {
      this.currentBodyClass = null;
    }
  }
}
